var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fb6a7ae8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "setting-drawer" };
const _hoisted_2 = { class: "setting-drawer__header" };
const _hoisted_3 = { class: "setting-drawer__title" };
const _hoisted_4 = { class: "setting-drawer__type" };
const _hoisted_5 = {
    key: 0,
    class: "padding-medium"
};
const _hoisted_6 = { class: "form" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "columns small-6" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Name", -1 /* HOISTED */));
const _hoisted_10 = ["value"];
const _hoisted_11 = { class: "columns small-6" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Display Name", -1 /* HOISTED */));
const _hoisted_13 = ["placeholder"];
const _hoisted_14 = { class: "row" };
const _hoisted_15 = { class: "columns small-12" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Description", -1 /* HOISTED */));
const _hoisted_17 = { class: "row" };
const _hoisted_18 = { class: "columns small-12" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tags", -1 /* HOISTED */));
const _hoisted_20 = { class: "row margin-bottom-small" };
const _hoisted_21 = { class: "columns small-12" };
const _hoisted_22 = { class: "row" };
const _hoisted_23 = { class: "columns small-12" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Priority", -1 /* HOISTED */));
const _hoisted_25 = {
    key: 0,
    class: "row"
};
const _hoisted_26 = {
    key: 1,
    class: "row"
};
const _hoisted_27 = { class: "columns small-12 margin-bottom-small" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Source", -1 /* HOISTED */));
const _hoisted_29 = { class: "button-wrapper" };
const _hoisted_30 = { class: "text-right" };
import ExtoleDrawer from "src/shared/v-components/ui/ExtoleDrawer.vue";
import { computed, ref, toRef } from "vue";
import Button from "../../ui/Button.vue";
import { useComponentStoreV2 } from "src/shared/store/component";
import notificationService from "../../ui/notification/notification-service";
import { useComponentMutableKeyForEditing } from "src/shared/store/component-mutable/composables/useComponentMutableKey";
import { useComponentSettingMutable } from "src/shared/store/component-mutable/composables/useComponentSettingMutable";
import { useBuiltComponentSetting } from "src/shared/store/component-built/composables/useBuiltComponentSetting";
import { ElInput } from "element-plus";
import TagSet from "../../ui/tags/TagSet.vue";
import Strings from "src/shared/Strings";
import ComponentVariableImportanceInput from "../drawer-common/ComponentVariableImportanceInput.vue";
import { useComponentVariableImportanceMutable } from "../drawer-common/useComponentVariableImportanceMutable";
import { isComponentVariableMutable } from "src/shared/store/component-mutable/model/ComponentVariableMutable";
import { isComponentSocketMutable } from "src/shared/store/component-mutable/model/ComponentSocketMutable";
import { isEnumComponentVariableMutable } from "src/shared/store/component-mutable/model/EnumComponentVariableMutable";
import { isPartnerEnumListComponentVariableMutable } from "src/shared/store/component-mutable/model/PartnerEnumListComponentVariableMutable";
import ComponentVariableMutableFields from "./ComponentVariableMutableFields.vue";
import SocketVariableMutableFields from "./SocketVariableMutableFields.vue";
import PartnerEnumListVariableMutableFields from "./PartnerEnumListVariableMutableFields.vue";
import CollapsedChipSingleSelect from "../../ui/form/CollapsedChipSingleSelect.vue";
import { sourceOptions } from "../drawer-common/sourceOptions";
import { confirm } from "../../ui/message-box";
import AllowedValuesEditor from "../drawer-common/AllowedValuesEditor.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditComponentSettingDrawer',
    props: {
        componentId: {},
        settingName: {}
    },
    emits: ["closed"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const componentStore = useComponentStoreV2();
        const { componentMutableKey } = useComponentMutableKeyForEditing(toRef(props, "componentId"));
        const { componentSettingMutable } = useComponentSettingMutable(componentMutableKey, toRef(props, "settingName"));
        const { builtComponentSetting } = useBuiltComponentSetting(toRef(props, "componentId"), toRef(props, "settingName"));
        const { importance } = useComponentVariableImportanceMutable(componentSettingMutable);
        const source = computed({
            get() {
                if (!componentSettingMutable.value ||
                    !isComponentVariableMutable(componentSettingMutable.value)) {
                    return null;
                }
                return componentSettingMutable.value.getSource();
            },
            set(value) {
                if (!componentSettingMutable.value ||
                    !isComponentVariableMutable(componentSettingMutable.value) ||
                    value === null) {
                    return;
                }
                componentSettingMutable.value.setSource(value);
            },
        });
        const isDirty = computed(() => {
            if (!componentSettingMutable.value) {
                return false;
            }
            return componentSettingMutable.value.isDirty();
        });
        const closeDrawer = () => {
            isShown.value = false;
        };
        const isShown = ref(true);
        const isSaving = ref(false);
        const emit = __emit;
        const save = () => __awaiter(this, void 0, void 0, function* () {
            if (!componentSettingMutable.value) {
                return;
            }
            try {
                isSaving.value = true;
                yield componentStore.updateComponentSetting(props.componentId, props.settingName, componentSettingMutable.value);
                notificationService.success("Setting has been updated");
                closeDrawer();
            }
            catch (error) {
                notificationService.error(error);
            }
            finally {
                isSaving.value = false;
            }
        });
        const deleteSetting = () => __awaiter(this, void 0, void 0, function* () {
            yield confirm({
                title: "Delete Setting",
                message: `Are you sure you want to delete ${props.settingName}?`,
                confirmButtonText: "Delete",
                onConfirm: (onSuccess, onError) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield componentStore.deleteComponentVariable(props.componentId, props.settingName);
                        notificationService.success("Setting has been deleted");
                        closeDrawer();
                        onSuccess();
                    }
                    catch (error) {
                        notificationService.error(error);
                        onError();
                    }
                }),
            });
        });
        // Composables for each field
        const displayName = computed({
            get: () => { var _a, _b; return (_b = (_a = componentSettingMutable.value) === null || _a === void 0 ? void 0 : _a.getDisplayName()) !== null && _b !== void 0 ? _b : null; },
            set: (value) => {
                if (componentSettingMutable.value) {
                    componentSettingMutable.value.setDisplayName(value);
                }
            },
        });
        const description = computed({
            get: () => { var _a, _b; return (_b = (_a = componentSettingMutable.value) === null || _a === void 0 ? void 0 : _a.getDescription()) !== null && _b !== void 0 ? _b : null; },
            set: (value) => {
                if (componentSettingMutable.value) {
                    componentSettingMutable.value.setDescription(value);
                }
            },
        });
        const tags = computed({
            get: () => { var _a, _b; return (_b = (_a = componentSettingMutable.value) === null || _a === void 0 ? void 0 : _a.getTags()) !== null && _b !== void 0 ? _b : []; },
            set: (value) => {
                if (componentSettingMutable.value) {
                    componentSettingMutable.value.setTags(value);
                }
            },
        });
        const priority = computed({
            get: () => { var _a, _b; return (_b = (_a = componentSettingMutable.value) === null || _a === void 0 ? void 0 : _a.getPriority()) !== null && _b !== void 0 ? _b : "0"; },
            set: (value) => {
                if (componentSettingMutable.value) {
                    componentSettingMutable.value.setPriority(value);
                }
            },
        });
        const type = computed(() => { var _a; return (_a = componentSettingMutable.value) === null || _a === void 0 ? void 0 : _a.getType(); });
        const name = computed(() => { var _a; return (_a = componentSettingMutable.value) === null || _a === void 0 ? void 0 : _a.getName(); });
        const formattedType = computed(() => {
            if (type.value) {
                return Strings.capitalize(type.value);
            }
            return "Unknown Type";
        });
        const isEnumSetting = computed(() => {
            return (componentSettingMutable.value &&
                isEnumComponentVariableMutable(componentSettingMutable.value));
        });
        const allowedValues = computed({
            get: () => {
                var _a;
                const setting = componentSettingMutable.value;
                if (!setting || !isEnumComponentVariableMutable(setting))
                    return [];
                return (_a = setting.getAllowedValues()) !== null && _a !== void 0 ? _a : [];
            },
            set: (value) => {
                const setting = componentSettingMutable.value;
                if (!setting || !isEnumComponentVariableMutable(setting))
                    return;
                setting.setAllowedValues(value);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ExtoleDrawer, {
                modelValue: isShown.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((isShown).value = $event)),
                onClosed: _cache[9] || (_cache[9] = ($event) => (emit('closed'))),
                showClose: false,
                width: '600px'
            }, {
                title: _withCtx(() => {
                    var _a;
                    return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("h1", _hoisted_3, " Edit " + _toDisplayString((_a = _unref(builtComponentSetting)) === null || _a === void 0 ? void 0 : _a.getDisplayName()), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_4, _toDisplayString(formattedType.value), 1 /* TEXT */)
                            ])
                        ])
                    ];
                }),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                        _createVNode(Button, {
                            level: 'tertiary',
                            onClick: deleteSetting,
                            class: "margin-right-small"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("Delete")
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createElementVNode("div", _hoisted_30, [
                            _createVNode(Button, {
                                level: 'secondary',
                                onClick: _cache[7] || (_cache[7] = ($event) => (closeDrawer())),
                                class: "margin-right-small"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Cancel")
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(Button, {
                                "is-pending": isSaving.value,
                                "is-disabled": !isDirty.value,
                                onClick: _withModifiers(save, ["prevent"])
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Save")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["is-pending", "is-disabled"])
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    (_unref(componentSettingMutable) && _unref(componentMutableKey))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("form", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _hoisted_9,
                                        _createElementVNode("input", {
                                            value: name.value,
                                            readonly: "",
                                            placeholder: "Name",
                                            type: "text"
                                        }, null, 8 /* PROPS */, _hoisted_10)
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _hoisted_12,
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((displayName).value = $event)),
                                            placeholder: _unref(Strings).capitalizeCamelCase(name.value),
                                            type: "text"
                                        }, null, 8 /* PROPS */, _hoisted_13), [
                                            [_vModelText, displayName.value]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createVNode(_unref(ElInput), {
                                            modelValue: description.value,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((description).value = $event)),
                                            autosize: "",
                                            type: "textarea",
                                            placeholder: "Please input"
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _hoisted_19,
                                        _createVNode(TagSet, {
                                            class: "margin-top-xsmall",
                                            tags: tags.value,
                                            "onUpdate:tags": _cache[2] || (_cache[2] = ($event) => ((tags).value = $event))
                                        }, null, 8 /* PROPS */, ["tags"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createVNode(ComponentVariableImportanceInput, {
                                            importance: _unref(importance),
                                            "onUpdate:importance": _cache[3] || (_cache[3] = ($event) => (_isRef(importance) ? (importance).value = $event : null))
                                        }, null, 8 /* PROPS */, ["importance"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _hoisted_24,
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((priority).value = $event)),
                                            type: "text"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, priority.value]
                                        ])
                                    ])
                                ]),
                                (isEnumSetting.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createVNode(AllowedValuesEditor, {
                                            modelValue: allowedValues.value,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((allowedValues).value = $event))
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (_unref(componentSettingMutable) &&
                                    _unref(isComponentVariableMutable)(_unref(componentSettingMutable)))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _hoisted_28,
                                            _createVNode(CollapsedChipSingleSelect, {
                                                modelValue: source.value,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((source).value = $event)),
                                                options: _unref(sourceOptions),
                                                size: "small"
                                            }, null, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (_unref(componentSettingMutable) &&
                                    _unref(isComponentVariableMutable)(_unref(componentSettingMutable)))
                                    ? (_openBlock(), _createBlock(ComponentVariableMutableFields, {
                                        key: 2,
                                        "component-mutable": _unref(componentSettingMutable)
                                    }, null, 8 /* PROPS */, ["component-mutable"]))
                                    : _createCommentVNode("v-if", true),
                                (_unref(componentSettingMutable) &&
                                    _unref(isComponentSocketMutable)(_unref(componentSettingMutable)))
                                    ? (_openBlock(), _createBlock(SocketVariableMutableFields, {
                                        key: 3,
                                        "component-mutable": _unref(componentSettingMutable)
                                    }, null, 8 /* PROPS */, ["component-mutable"]))
                                    : _createCommentVNode("v-if", true),
                                (_unref(componentSettingMutable) &&
                                    _unref(isPartnerEnumListComponentVariableMutable)(_unref(componentSettingMutable)))
                                    ? (_openBlock(), _createBlock(PartnerEnumListVariableMutableFields, {
                                        key: 4,
                                        "component-mutable": _unref(componentSettingMutable)
                                    }, null, 8 /* PROPS */, ["component-mutable"]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
